<template>
  <div class="container mx-auto px-4 py-8 max-w-4xl">
    <div class="flex justify-between items-center mb-8">
      <h1 class="text-3xl font-bold text-gray-800">Avsmakningsmenyer</h1>
      <a
        v-if="currentUser?.admin"
        :href="newTastingMenuPath"
        class="bg-emerald-600 text-white px-4 py-2 rounded-lg hover:bg-emerald-700 transition-colors"
      >
        Skapa ny meny
      </a>
    </div>

    <div v-if="menus.length === 0" class="text-center py-16 text-gray-500">
      <PhNotePencil :size="48" class="mx-auto mb-4 opacity-50" />
      <p class="text-lg">Inga avsmakningsmenyer ännu.</p>
    </div>

    <div class="grid gap-4">
      <a
        v-for="menu in menus"
        :key="menu.id"
        :href="menu.path"
        class="bg-white rounded-lg shadow p-6 hover:shadow-md transition-shadow block"
      >
        <div class="flex justify-between items-start">
          <div>
            <h2 class="text-xl font-semibold text-gray-800">
              {{ menu.title }}
            </h2>
            <p v-if="menu.description" class="text-gray-500 mt-1">
              {{ menu.description }}
            </p>
            <div class="flex gap-4 mt-3 text-sm text-gray-400">
              <span>{{ menu.courseCount }} rätter</span>
              <span>{{ menu.createdAt }}</span>
            </div>
          </div>
          <div class="flex gap-2">
            <a
              :href="menu.previewPath"
              class="text-emerald-600 hover:text-emerald-800 text-sm"
              @click.stop
            >
              Förhandsgranska
            </a>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script setup>
import { PhNotePencil } from "@phosphor-icons/vue";

defineProps({
  menus: { type: Array, required: true },
  currentUser: Object,
  csrfToken: String,
  newTastingMenuPath: String,
});
</script>
